import { validatenull } from '@/utils/validate'
import website from '@/const/website'

const keyName = website.key + '-'
const isSession = type => type && type === 'session'
/**
 * 存储localStorage
 */
export const setStore = (params = {}) => {
  const { name, content, type } = params
  const key = keyName + name
  const obj = {
    dataType: typeof content,
    content: content,
    type: type,
    datetime: new Date().getTime()
  }

  if (isSession(type)) {
    window.sessionStorage.setItem(key, JSON.stringify(obj))
  } else {
    window.localStorage.setItem(key, JSON.stringify(obj))
  }
}

export const setSession = params => setStore({ ...params, type: 'session' })
/**
 * 获取localStorage
 */

// default is localStorage
export const getStore = (params = {}) => {
  const { name, debug, type } = params
  const key = keyName + name

  let content
  let obj = isSession(type) ? window.sessionStorage.getItem(key) : window.localStorage.getItem(key)

  if (validatenull(obj)) return obj
  try {
    obj = JSON.parse(obj)
  } catch {
    return obj
  }
  if (debug) {
    return obj
  }
  if (obj.dataType === 'number') {
    content = Number(obj.content)
  } else {
    content = obj.content
  }
  return content
}

export const getSession = params => getStore({ ...params, type: 'session' })
/**
 * 删除localStorage
 */
export const removeStore = (params = {}) => {
  const { name, type } = params
  const key = keyName + name
  if (isSession(type)) {
    window.sessionStorage.removeItem(key)
  } else {
    window.localStorage.removeItem(key)
  }
}

export const removeSession = name => {
  removeStore({ name, type: 'session' })
}

export const setTenantId = tenantId => {
  setSession({ name: 'tenant_id', content: tenantId })
}

export const getTenantId = () => getSession({ name: 'tenant_id' })

export const setAccessToken = token => {
  setSession({ name: 'access_token', content: token })
}

export const getAccessToken = () => getSession({ name: 'access_token' })

export const setRefreshToken = token => {
  setSession({ name: 'refresh_token', content: token })
}

export const getRefreshToken = () => getSession({ name: 'refresh_token' })
